import { BaseError } from './base';

export function MissingQueryError(message, debug, code, kinveyRequestId) {
  this.name = 'MissingQueryError';
  this.message = message || 'The request is missing a query string.';
  this.debug = debug || undefined;
  this.code = code || undefined;
  this.kinveyRequestId = kinveyRequestId || undefined;
  this.stack = (new Error()).stack;
}
MissingQueryError.prototype = Object.create(BaseError.prototype);
MissingQueryError.prototype.constructor = MissingQueryError;



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/errors/missingQuery.js